import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { DurationFilter } from 'components/common/CustomFilters/DurationFilter/DurationFilter';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';

export const Duration = ({ isSelected, onFiltersChanged }) => {
    const { control } = useFormContext<IFields>();
    return isSelected ? (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Duration</span>
            <Controller
                render={({ field }) => (
                    <DurationFilter
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                    />
                )}
                name={'duration'}
                control={control}
            />
        </div>
    ) : null;
};
